import Markdown from '.';
import styled from 'styled-components';

const SmallMarkdown = styled(Markdown)`
  * {
    line-height: 1.2;
    margin-top: 8px;
  }
  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 14px;
  }

  a,
  li {
    font-size: 14px;
  }

  code {
    font-size: 14px;
  }
`;

export default SmallMarkdown;
